import SectionHeading from "@/pages/home/components/SectionHeading";
import { datingSteps } from "@/mocks/content";

export default function DatingSection() {
  return (
    <section id="dating" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading
          eyebrow="约会攻略"
          title="一次好的约会，从准备就开始"
          desc="约会不是一场考试，而是一段互相了解的过程。把它拆成四个阶段，你会发现每一步都有可以提前准备的地方。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {datingSteps.map((step) => (
            <div key={step.label} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{step.label}</h3>
                <span className="rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900">
                  {step.subtitle}
                </span>
              </div>
              <ul className="mt-4 space-y-4">
                {step.points.map((point) => (
                  <li key={point.t} className="flex gap-3">
                    <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-primary-200 bg-primary-50 text-primary-600">
                      <i className="ri-arrow-right-s-line text-sm"></i>
                    </span>
                    <div>
                      <p className="font-label text-sm font-medium text-foreground-900">{point.t}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{point.d}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}